<div class="container">
    <div class="title">רשימת קמפיינים</div>
    <app-campaign-search></app-campaign-search>
</div>
